import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewRenspa = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'renspa',
        name: 'Renspa',
        component: ViewRenspa,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
